const UserBlockRemove = () => {
  return (
    <svg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_2949_51163)'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.71429 6.85714C7.60783 6.85714 9.14286 5.32211 9.14286 3.42857C9.14286 1.53503 7.60783 0 5.71429 0C3.82074 0 2.28571 1.53503 2.28571 3.42857C2.28571 5.32211 3.82074 6.85714 5.71429 6.85714ZM5.71429 7.99997C6.23345 7.99997 6.73645 8.0692 7.21455 8.19894C6.45671 9.16801 6.00362 10.3902 6.00362 11.716C6.00362 12.6403 6.22312 13.5133 6.61282 14.2857H0.571429C0.255838 14.2857 0 14.0298 0 13.7143C0 10.5583 2.55838 7.99997 5.71429 7.99997Z'
          fill='#FF6B6B'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M14.285 11.7154C14.285 10.2964 13.1346 9.14593 11.7154 9.14593C11.319 9.14593 10.9435 9.23571 10.6082 9.39606L14.0349 12.8228C14.1953 12.4874 14.285 12.1119 14.285 11.7154ZM14.7994 14.6888C15.5424 13.9184 15.9993 12.8703 15.9993 11.7154C15.9993 9.34958 14.0814 7.43164 11.7154 7.43164C10.5609 7.43164 9.51305 7.88838 8.74267 8.63106C8.72261 8.64775 8.70315 8.66551 8.68433 8.68433C8.66551 8.70314 8.64775 8.72261 8.63106 8.74267C7.88839 9.51305 7.43164 10.5609 7.43164 11.7154C7.43164 14.0814 9.34959 15.9993 11.7154 15.9993C12.8703 15.9993 13.9184 15.5424 14.6888 14.7994C14.7087 14.7829 14.728 14.7653 14.7466 14.7466C14.7653 14.728 14.7829 14.7087 14.7994 14.6888ZM12.8228 14.0349L9.39606 10.6082C9.23572 10.9435 9.14593 11.319 9.14593 11.7154C9.14593 13.1346 10.2964 14.285 11.7154 14.285C12.1119 14.285 12.4874 14.1952 12.8228 14.0349Z'
          fill='#FF6B6B'
        />
      </g>
      <defs>
        <clipPath id='clip0_2949_51163'>
          <rect width='16' height='16' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UserBlockRemove;
